interface AgendaNameSource {
  displayAs?: string;
  name?: string;
}

export const resolveAgendaName = (source?: AgendaNameSource, fallback?: string): string => source?.displayAs ?? source?.name ?? fallback ?? '';
